// extracted by mini-css-extract-plugin
export var body = "Body-module--body--c4259";